module.exports = __webpack_public_path__ + "img/hifu.fa0dd35c.png";